<ng-container *mobxAutorun>
  <!-- Title -->
  <h5 class="modal-title"><ng-content></ng-content></h5>

  <!-- Close button -->
  <button
    *ngIf="showCloseButton"
    type="button"
    class="close"
    [title]="closeButtonTooltip"
    [attr.aria-label]="closeButtonTooltip"
    (click)="hide()"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</ng-container>
